import normalize from "json-api-normalize";
import Attributes from "../../models/Attributes.js";
import Vue from 'vue';

export const SubscriptionsApi = {
  createSubscription(params) {
    return Vue.http.post("/api/customers/subscriptions", params).then(fulfilled => {
      return normalize(fulfilled.body).get(Attributes.subscriptionAttributes);
    })
  },

  createPurchaseOrderSubscription(params) {
    return Vue.http.post("/api/customers/purchase_orders", params).then(fulfilled => {
      return normalize(fulfilled.body).get(Attributes.subscriptionAttributes);
    })
  },

  getSubscription() {
    return Vue.http.get("/api/customers/subscriptions").then(fulfilled => {
      return normalize(fulfilled.body).get(Attributes.subscriptionAttributes);
    })
  },

  cancelSubscription(id, reason) {
    return Vue.http.patch(`/api/customers/subscriptions/${id}/cancel`, { cancel_reason: reason } )
  },

  reactivateSubscription(id) {
    return Vue.http.patch(`/api/customers/subscriptions/${id}/reactivate`)
  }
}